import { createPortal } from "react-dom";
import { useEffect } from "react";
function Modal({ children }) {
  useEffect(() => {
    document.body.classList.add("lockscroll");
    return () => {
      document.body.classList.remove("lockscroll");
    };
  }, []);
  return createPortal(
    <div className="modal">
      <div className="modal__content">{children}</div>
    </div>,
    document.getElementById("modal")
  );
}
export default Modal;
